import { timeToMinutes } from '../../../shared/packages/dateTime';

export class Time {
  constructor(time, context) {
    this.value = time;
    this.minutes = timeToMinutes(time);
    this.context = context;
  }
}
